import DashboardSearchAppLayout from "@components_common/components/layouts/DashboardSearchAppLayout";

export default DashboardSearchAppLayout;
